/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox {

    import fld = ChatroomsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class ConversationsGrid extends NoboxEntityGrid<ChatroomsRow, any> {
        protected getColumnsKey() { return ChatroomsColumns.columnsKey; }
        protected getDialogType() { return ChatroomsDialog; }
        protected getIdProperty() { return ChatroomsRow.idProperty; }
        protected getInsertPermission() { return ChatroomsRow.insertPermission; }
        protected getLocalTextPrefix() { return ChatroomsRow.localTextPrefix; }
        protected getService() { return ChatroomsService.baseUrl; }

        private columnStyles() {
            var dataStorage = window.localStorage;
            var hasil = {};
            if (dataStorage != null) {
                var column = dataStorage["GridSettings:Messages/Conversations:Nobox.ConversationsGrid"];
                if (!Q.isEmptyOrNull(column)) {
                    var data = JSON.parse(column).columns;
                    var index = data.findIndex(fy => fy.id == "LastMsg");
                    hasil[index] = { cellWidth: 200 };
                } else {
                    hasil[6] = { cellWidth: 200 };
                }
            }
            return hasil;
        };
        constructor(container: JQuery) {
            super(container);
            var q = Q.parseQueryString();
            if (q["st"]) {
                this.findQuickFilter(StatusConversationEditor, ChatroomsRow.Fields.St).value = q["st"];
            }
            if (q["sd"] && q["ed"]) {
                var categoryDt = this.findQuickFilter(CustomDateFilter, ChatroomsRow.Fields.In);
                if (q["sd"] == "All" || q["ed"] == "All") {
                    categoryDt.set_value(null);
                    categoryDt.end_set_value(null);
                } else {
                    categoryDt.set_value(q["sd"]);
                    categoryDt.end_set_value(q["ed"]);
                }
            }
        }
        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();
            let listChannel = Q.getLookup("Nobox.ChannelAutomationLookup").itemById as unknown as Master.ChannelRow[];
            let listAkun = Q.getLookup("Nobox.AccountLookup").itemById as unknown as Nobox.AccountRow[];
            let lists = Q.getLookup("Nobox.ChatTagsLookup").itemById as unknown as ChattagsRow[];
            columns.unshift({
                field: 'Go To Conversation',
                name: '',
                format: ctx => {
                    return '<a href="javascript:;" title="Go to conversation"><i class="fa fa-share text-primary room-link"></i></a>';
                },
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            Q.first(columns, x => x.field == ChatroomsRow.Fields.ChId).format =
                ctx => `<a href="javascript:;" title="Channel" class="channel-link">${listChannel[ctx.value] == undefined ? "-" : listChannel[ctx.value].Nm}</a>`;
            Q.first(columns, x => x.field == ChatroomsRow.Fields.ChAccId).format =
                ctx => `<a href="javascript:;" title="Account" class="account-link">${listAkun[ctx.value] == undefined ? "-" : listAkun[ctx.value].Name}</a>`;
            Q.first(columns, x => x.field == ChatroomsRow.Fields.CtRealNm).format =
                ctx => {
                    if (Q.isEmptyOrNull(ctx.value)) {
                        return "";
                    } else {
                        return `<a href="javascript:;" title="Contact" class="contact-link">${ctx.value}</a>`
                    }
                };
            Q.first(columns, x => x.field == ChatroomsRow.Fields.Ct).format =
                ctx => {
                    if (Q.isEmptyOrNull(ctx.value)) {
                        return "";
                    } else {
                        return `<a href="javascript:;" title="Link" class="link-link">${ctx.value}</a>`;
                    }
                };
            Q.first(columns, x => x.field == ChatroomsRow.Fields.Grp).format =
                ctx => {
                    if (Q.isEmptyOrNull(ctx.value)) {
                        return "";
                    } else {
                        return `<a href="javascript:;" title="Link" class="link-group">${ctx.value}</a>`;
                    }
                };
            Q.first(columns, x => x.field == ChatroomsRow.Fields.Fn).format =
                ctx => {
                    if (Q.isEmptyOrNull(ctx.value)) {
                        return "";
                    } else {
                        return `<a href="javascript:;" title="Funnel" class="funnel-link">${ctx.value}</a>`
                    }
                };
            Q.first(columns, x => x.field == ChatroomsRow.Fields.Deal).format =
                ctx => {
                    if (Q.isEmptyOrNull(ctx.value)) {
                        return "";
                    } else {
                        return `<a href="javascript:;" title="Deal" class="deal-link">${ctx.value}</a>`
                    }
                };
            Q.first(columns, x => x.field == ChatroomsRow.Fields.Campaign).format =
                ctx => {
                    if (Q.isEmptyOrNull(ctx.value)) {
                        return "";
                    } else {
                        return `<a href="javascript:;" title="Campaign" class="campaign-link">${ctx.value}</a>`;
                    }
                };
            Q.first(columns, x => x.field == ChatroomsRow.Fields.AgentIds).format =
                ctx => {
                    if (!ctx.value)
                        return "";

                    var arr = JSON.parse(ctx.value) as any;
                    var elList = "";
                    arr.forEach((fy, i) => {
                        if (i != arr.length - 1) {
                            elList += `<span id="${fy.Id}" class="agent-link">${fy.Nm}, </span>`;
                        } else {
                            elList += `<span id="${fy.Id}" class="agent-link">${fy.Nm}</span>`;
                        }
                    })
                    return `<a href="javascript:;">${elList} </a>`;
                };
            Q.first(columns, x => x.field == fld.TagsIds).format =
                ctx => {
                    let idList = ctx.value;
                    if (!idList)
                        return "";

                    idList = JSON.parse(idList) as number[]
                    var elList = "";
                    var idLast = 0;
                    idList.forEach(function (x) {
                        let g = lists[BigInt(x)] as any;
                        idLast = x;
                        if (!g) {
                            elList += `<span id="${x.toString()}" class="tags-link">${x.toString()}, </span>`;
                        } else {
                            elList += `<span id="${x.toString()}" class="tags-link">${Q.htmlEncode(g.Nm)}, </span>`;
                        }
                    });
                    if (lists[BigInt(idLast)]) {
                        return `<a href="javascript:;">${elList.replace(lists[BigInt(idLast)].Nm + ", ", lists[BigInt(idLast)].Nm)}</a>`;
                    } else {
                        return `<a href="javascript:;">${elList.replace(idLast.toString() + ", ", idLast.toString())} </a>`;
                    }
                };

            return columns;
        }

        protected getButtons() {
            var buttons = super.getButtons();
            var $this = this;
            buttons.splice(0, 1);
            return buttons;
        }

        protected getViewOptions() {
            let opt = super.getViewOptions();
            //Default option
            opt.rowsPerPage = 20;
            opt.url = Q.resolveUrl('~/Services/' + this.getService() + '/ListWithoutTags')
            return opt;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);
            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            if (target.hasClass("room-link")) {
                var baseUrl = "/Messages/Inbox?RoomId=";
                if (item.St == 4)
                    baseUrl = "/Messages/Inbox?Archived=1&RoomId=";

                window.open(baseUrl + item.Id)
            } else if (target.hasClass("channel-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by channel");
                this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatroomsRow.Fields.ChId).set_value(`${item.ChId}`);
                this.refresh();
            } else if (target.hasClass("account-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by account");
                this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatroomsRow.Fields.ChId).set_value(`${item.ChId}`);
                this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatroomsRow.Fields.ChAccId).set_value(`${item.ChAccId}`);
                this.refresh();
            } else if (target.hasClass("contact-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by contact");
                this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatroomsRow.Fields.CtRealId).set_value(`${item.CtRealId}`);
                this.refresh();
            } else if (target.hasClass("link-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by link");
                this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatroomsRow.Fields.ChId).set_value(`${item.ChId}`);
                this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatroomsRow.Fields.CtId).set_value(`${item.CtId}`);
                this.refresh();
            }  else if (target.hasClass("link-group")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by group");
                this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatroomsRow.Fields.ChId).set_value(`${item.ChId}`);
                this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatroomsRow.Fields.GrpId).set_value(`${item.GrpId}`);
                this.refresh();
            } else if (target.hasClass("deal-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by deal");
                this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatroomsRow.Fields.DealId).set_value(`${item.DealId}`);
                this.refresh();
            } else if (target.hasClass("campaign-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by campaign");
                this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatroomsRow.Fields.ChId).set_value(`${item.ChId}`);
                this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatroomsRow.Fields.CampaignId).set_value(`${item.CampaignId}`);
                this.refresh();
            } else if (target.hasClass("funnel-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by funnel");
                this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatroomsRow.Fields.FnId).set_value(`${item.FnId}`);
                this.refresh();
            } else if (target.hasClass("tags-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by tags");
                var listFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatroomsRow.Fields.TagsIds);
                listFilter.set_value(listFilter.get_value() + "," + target.attr("id"));
                this.refresh();
            } else if (target.hasClass("agent-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by agent");
                var listFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatroomsRow.Fields.AgentIds);
                listFilter.set_value(listFilter.get_value() + "," + target.attr("id"));
                this.refresh();
            } 
        }

        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            request.IncludeColumns = [
                "Go To Conversation",
                "St",
                "ChId",
                "ChAccId",
                "CtRealNm",
                "Ct",
                "LastMsg",
                "Deal",
                "Campaign",
                "In",
                "Up",
                "DealId",
                "FnId",
                "CampaignId"
            ]
            ////request.ColumnSelection = 1;
            return true;
        }

        //protected createSlickGrid(): Slick.Grid {
        //    var grid = super.createSlickGrid();
        //    grid.setSelectionModel(new Slick.RowSelectionModel());
        //    return grid;
        //}
        protected getQuickFilters() {
            var flt = super.getQuickFilters();

            var filter1 = Q.first(flt, x => x.field == ChatroomsRow.Fields.In);
            filter1.handler = h => {
                const request = (h.request as ChatroomsListRequest);
                const start = (h.widget as CustomDateFilter).get_value();
                const end = (h.widget as CustomDateFilter).end_get_value();
                if (start != null && end != null) {
                    request.Criteria = [[["In"], ">=", start], "and", [["In"], "<=", end]]
                } else if (start != null) {
                    request.Criteria = [["In"], ">=", start];
                } else if (end != null) {
                    request.Criteria = [["In"], "<=", end];
                } else {
                    request.Criteria = null;
                }
                h.handled = true;
                //if (h.active) {
                //    if (start != null && end != null) {
                //        request.Criteria = [[["In"], ">=", start], "and", [["In"], "<=", end]]
                //    } else if (start != null) {
                //        request.Criteria = [["In"], ">=", start];
                //    } else if (end != null) {
                //        request.Criteria = [["In"], "<=", end];
                //    }
                //    h.handled = true;
                //} else {
                //    request.Criteria = null;
                //    h.handled = true;
                //}
            };
            var filter2 = Q.first(flt, x => x.field == ChatroomsRow.Fields.TagsIds);
            filter2.handler = h => {
                const request = (h.request as ChatroomsListRequest);
                var hasil = (h.widget as Serenity.ServiceLookupEditor).get_value();
                if (h.active) {
                    request.TagsIds = hasil.split(",");
                    h.handled = true;
                } else {
                    request.TagsIds = null;
                    h.handled = true;
                }
            };
            var filter3 = Q.first(flt, x => x.field == ChatroomsRow.Fields.AgentIds);
            filter3.handler = h => {
                const request = (h.request as ChatroomsListRequest);
                var hasil = (h.widget as Serenity.ServiceLookupEditor).get_value();
                if (h.active) {
                    request.UserIds = hasil.split(",");
                    h.handled = true;
                } else {
                    request.UserIds = null;
                    h.handled = true;
                }
            };
            var filter4 = Q.first(flt, x => x.field == ChatroomsRow.Fields.IsGrp);
            filter4.handler = h => {
                const request = (h.request as ChatroomsListRequest);
                var hasil = (h.widget as TypeChatConversation).get_value();
                if (h.active) {
                    request.Chat = hasil;
                    h.handled = true;
                } else {
                    request.Chat = null;
                    h.handled = true;
                }
            };
            return flt;
        }
    }
}